.page {
  display: grid;
  grid-template-columns: var(--measure-rail) minmax(0, 1fr);
  gap: var(--space-xl);
  align-items: start;

  margin-inline: auto;
  padding: var(--space-xl) var(--space-l) var(--space-2xl);
  max-width: var(--measure-page);
}

.rail {
  position: sticky;
  top: var(--space-l);

  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  padding: var(--space-m);

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-m);
}

.railTitle {
  font-size: var(--size-100);
  font-weight: var(--weight-medium);
  letter-spacing: 0.03em;
  text-transform: uppercase;

  color: var(--text-faint);
}

.railCount {
  font-variant-numeric: tabular-nums;

  color: var(--text-faint);
}

.main {
  display: flex;
  flex-direction: column;
  gap: var(--space-l);
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.headerTop {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--space-s);
}

.intro {
  font-size: var(--size-300);

  color: var(--text-muted);
}

/* Off screen until a keyboard reaches it, then a normal link at the top. */
.skipLink {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;

  clip-path: inset(50%);
}

.skipLink:focus-visible {
  position: static;
  overflow: visible;
  width: auto;
  height: auto;

  clip-path: none;
}

.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);
}

.group:focus {
  outline: none;
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  padding: var(--space-m);

  background-color: var(--surface);

  border-radius: var(--radius-s);

  &:first-of-type {
      border-top-left-radius: var(--radius-m);
      border-top-right-radius: var(--radius-m);
  }

  &:last-of-type {
      border-bottom-left-radius: var(--radius-m);
      border-bottom-right-radius: var(--radius-m);
  }
}

.cardHead {
  display: flex;
  flex-direction: column;
  gap: var(--space-3xs);
}

.cardTitle {
  font-size: var(--size-400);
  font-weight: var(--weight-medium);
}

.cardBody {
  font-size: var(--size-200);

  color: var(--text-muted);
}

.tag {
  align-self: flex-start;

  padding: var(--space-3xs) var(--space-xs);

  font-size: var(--size-100);

  color: var(--text-muted);
  background-color: var(--surface-sunken);

  border-radius: var(--radius-pill);
}

.notes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: var(--space-s);
}

.status {
  font-size: var(--size-100);
  font-variant-numeric: tabular-nums;

  color: var(--text-faint);
}

.statusFailed {
  color: var(--band-missing);
}

.footer {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
  align-items: flex-start;
}

.terminal {
  display: flex;
  flex-direction: column;
  gap: var(--space-s);

  margin-inline: auto;
  padding: var(--space-2xl) var(--space-l);
  max-width: 34rem;

  text-align: center;
}

/*
 * Last in the file on purpose: these override the rules above them, and a media
 * query carries no extra weight of its own, so one placed earlier would simply
 * be overwritten by the base rule it means to correct.
 */
/* Tablet: the rail stops being a column and rides along above the questions. */
@media (max-width: 60rem) {
  .page {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-l);
  }

  .rail {
    position: static;
  }
}

@media (max-width: 40rem) {
  .page {
    padding: var(--space-l) var(--space-m) var(--space-xl);
  }

  .notes {
    grid-template-columns: minmax(0, 1fr);
  }
}
